/* Note: Every GTM values must be kept here */
export const UI_TRIGGERED = `[UI] TRIGGERED`

export const UI_YES_BUTTON_CLICKED = `[UI] YES BUTTON CLICKED`
export const UI_NO_BUTTON_CLICKED = `[UI] NO BUTTON CLICKED`

export const UI_INVITE_USER_DIALOG_OPEN = `[UI] INVITE USER DIALOG OPEN`
export const UI_USER_INVITED = `[UI] USER INVITED`
export const UI_USER_TYPE_UPDATED = `[UI] USER TYPE UPDATED`

export const UI_REPORT_REQUESTED = `[UI] REPORT REQUESTED`

export const UI_DOCKET_DETAILS_DIALOG_OPEN = `[UI] DOCKET DETAILS DIALOG OPEN`
export const UI_NOTIFICATIONS_DIALOG_OPEN = `[UI] NOTIFICATIONS DIALOG OPEN`
export const UI_NOTIFICATIONS_SETTINGS_DIALOG_OPEN = `[UI] NOTIFICATIONS SETTINGS DIALOG OPEN`
export const UI_EDIT_PROFILE_CLICK = `[UI] EDIT PROFILE CLICK`

export const UI_DOCKET_DETAILS_DIALOG_OPEN_DOCKETS_PAGE = `[UI] DOCKET DETAILS DIALOG OPEN DOCKETS PAGE`
export const UI_DOCKET_DOWNLOAD_DOCKETS_PAGE = `[UI] DOCKET DOWNLOAD DOCKETS PAGE`
export const UI_DOCKET_ACCEPT_ATTEMPT = `[UI] DOCKET ACCEPT ATTEMPT`
export const UI_DOCKET_ORDER_VIEWED_DOCKETS_PAGE = `[UI] DOCKET ORDER VIEWED DOCKETS PAGE`
export const UI_DOCKET_DETAILS_DOCKETS_PAGE = `[UI] DOCKET DETAILS DOCKETS PAGE`
export const UI_DOCKET_DATE_RANGE_CHANGE_DOCKETS_PAGE = `[UI] DOCKET DATE RANGE CHANGE DOCKETS PAGE`
export const UI_DOCKET_ACCOUNT_CHANGE_DOCKETS_PAGE = `[UI] DOCKET ACCOUNT CHANGE DOCKETS PAGE`
export const UI_DOCKET_COLUMNS_CHANGE_DOCKETS_PAGE = `[UI] DOCKET COLUMNS CHANGE DOCKETS PAGE`
export const UI_DOWNLOAD_DATE_RANGE_DOCKETS_PAGE = `[UI] UI DOWNLOAD DATE RANGE DOCKETS PAGE`
export const UI_DOWNLOAD_DATE_RANGE_PDF_DOCKETS_PAGE = `[UI] UI DOWNLOAD DATE RANGE PDF DOCKETS PAGE`
export const UI_DOWNLOAD_CSV_DOCKETS_PAGE = `[UI] UI DOWNLOAD CSV DOCKETS PAGE`
export const UI_DOWNLOAD_PDF_DOCKETS_PAGE = `[UI] UI DOWNLOAD PDF DOCKETS PAGE`
export const UI_DOCKET_MODAL_TAB_CHANGE = `[UI] UI DOCKET MODAL TAB CHANGE`
export const UI_DOCKET_MODAL_DELETE_NOTE_ATTEMPT = `[UI] UI DOCKET MODAL DELETE NOTE ATTEMPT`
export const UI_DOCKET_MODAL_SHOW_DELETE_CONFIRM = `[UI] UI DOCKET MODAL SHOW DELETE CONFIRM`
export const UI_DOCKET_CALL_REPORT_ISSUE = `[UI] UI DOCKET CALL REPORT ISSUE`
export const UI_DOCKET_LIST_REPORT_ISSUE = `[UI] UI DOCKET LIST REPORT ISSUE`
export const UI_DOCKET_MODAL_REPORT_ISSUE = `[UI] UI DOCKET MODAL REPORT ISSUE`
export const UI_ORDER_PAGE_ORDER_CLICKED = `[UI] UI ORDER PAGE ORDER CLICKED`

export const UI_SPEED_DIAL_MAIN_BUTTON_CLICKED = `[UI] SPEED DIAL MAIN BUTTON CLICKED`
export const UI_SPEED_DIAL_SUB_BUTTON_CLICKED = `[UI] SPEED DIAL SUB BUTTON CLICKED`

export const UI_CONCRETE_DELIVERIES_BUTTON_CLICKED = `[UI] CONCRETE DELIVERIES BUTTON CLICKED`
export const UI_ORDER_PROGRESS_PLUS_LOAD_CALL_BORAL_CLICK = `[UI] ORDER PROGRESS PLUS LOAD CALL BORAL CLICK`

export const UI_EXPANSION_PANEL_EXPANDED = `[UI] EXPANSION PANEL EXPANDED`
export const UI_EXPANSION_PANEL_COLLAPSED = `[UI] EXPANSION PANEL COLLAPSED`
export const UI_DELIVERED_EXPANSION_PANEL_EXPANDED = `TRUCKS PANE - DELIVERED EXPANSION PANEL EXPANDED`
export const UI_DELIVERED_EXPANSION_PANEL_COLLAPSED = `TRUCKS PANE - DELIVERED EXPANSION PANEL COLLAPSED`
export const UI_IN_TRANSIT_EXPANSION_PANEL_EXPANDED = `TRUCKS PANE - IN TRANSIT EXPANSION PANEL EXPANDED`
export const UI_IN_TRANSIT_EXPANSION_PANEL_COLLAPSED = `TRUCKS PANE - IN TRANSIT EXPANSION PANEL COLLAPSED`
export const UI_SCHEDULED_EXPANSION_PANEL_EXPANDED = `TRUCKS PANE - SCHEDULED EXPANSION PANEL EXPANDED`
export const UI_SCHEDULED_EXPANSION_PANEL_COLLAPSED = `TRUCKS PANE - SCHEDULED EXPANSION PANEL COLLAPSED`
export const UI_SCHEDULED_EXPANSION_PANEL_DOCKET_OPEN = `TRUCKS PANE - SCHEDULED EXPANSION PANEL DOCKET OPEN`

export const UI_FILTER_ADDRESS_TYPED = `[UI] FILTER ADDRESS TYPED`
export const UI_FILTER_ADDRESS_CLOSED = `[UI] FILTER ADDRESS CLOSED`
export const UI_FILTER_ADDRESS_ABANDONED = `[UI] FILTER ADDRESS ABANDONED`
export const UI_FILTER_ADDRESS_SEARCH_RESULT_SELECTED = `[UI] FILTER ADDRESS SEARCH RESULT SELECTED`
export const UI_FILTER_ADDRESS_ITEM_TOGGLED_ON = `[UI] FILTER ADDRESS ITEM TOGGLED ON`
export const UI_FILTER_ADDRESS_ITEM_TOGGLED_OFF = `[UI] FILTER ADDRESS ITEM TOGGLED OFF`
export const UI_FILTER_ADDRESS_ITEM_REMOVED = `[UI] FILTER ADDRESS ITEM REMOVED`
export const UI_FILTER_ADDRESS_TOGGLE_ALL = `[UI] FILTER ADDRESS TOGGLE ALL`
export const UI_FILTER_ADDRESS_REMOVE_ALL = `[UI] FILTER ADDRESS REMOVE ALL`

export const UI_FILTER_ORDER_STATUS_SHOW_ALL = `[UI] FILTER ORDER STATUS SHOW ALL`
export const UI_ORDER_LIST_REFRESH = `[UI] ORDER LIST REFRESH`

export const UI_SHOW_ACTIVITY_LOG = `[UI] SHOW ACTIVITY LOG`

export const UI_DASHBOARD_MY_ORDERS_CLICKED = `DASHBOARD - MYORDERS CLICK`
export const UI_DASHBOARD_MY_DOCKETS_CLICKED = `DASHBOARD - MYDOCKETS CLICK`
export const UI_DASHBOARD_PLACE_NEW_ORDER_CLICKED = `DASHBOARD - PLACE NEW ORDER CLICK`
export const UI_DASHBOARD_VIEW_MY_ACCOUNTS_CLICKED = `DASHBOARD - VIEW MY ACCOUNTS CLICK`
export const UI_DASHBOARD_ADD_MANAGE_PEOPLE_CLICKED = `DASHBOARD - ADD MANAGE PEOPLE CLICK`
export const UI_DASHBOARD_GENERATE_VOLUME_REPORT_CLICKED = `DASHBOARD - GENERATE VOLUME REPORT CLICK`
export const UI_DASHBOARD_GENERATE_DOCKET_REPORT_CLICKED = `DASHBOARD - GENERATE DOCKET REPORT CLICK`
export const UI_DASHBOARD_REPORTS_TILE_CLICKED = `DASHBOARD - REPORTS TILE CLICKED`
export const UI_DASHBOARD_ACCOUNTS_TILE_CLICKED = `DASHBOARD - ACCOUNTS TILE CLICKED`
export const UI_DASHBOARD_DOCKETS_TILE_CLICKED = `DASHBOARD - DOCKETS TILE CLICKED`
export const UI_DASHBOARD_ORDERS_TILE_CLICKED = `DASHBOARD - ORDERS TILE CLICKED`

export const UI_DOCKET_OPEN_ADD_NOTE = `[UI] DOCKET OPEN ADD NOTE`
export const UI_DOCKET_CLOSE_ADD_NOTE = `[UI] DOCKET CLOSE ADD NOTE`
export const UI_DOCKET_ADD_NOTE = `[UI] DOCKET ADD NOTE`
export const UI_DOCKET_MODAL_CANCEL_DELETE_NOTE = `[UI] DOCKET MODAL CANCEL DELETE NOTE`
export const UI_DOCKET_MODAL_DOWNLOAD_PDF_BUTTON_CLICK = `[UI] DOCKET MODAL DOWNLOAD PDF BUTTON CLICK`

export const UI_PROJECT_FILTER_MODAL_CLOSE = `[UI] PROJECT FILTER MODAL CLOSE`
export const UI_PROJECT_FILTER_MODAL_APPLY_CLICK = `[UI] PROJECT FILTER MODAL APPLY CLICK`
export const UI_PROJECT_FILTER_MODAL_OPEN = `[UI] PROJECT FILTER MODAL OPEN`

export const UI_PROJECT_SELECTOR_PROJECT_SELECTED = `[UI] PROJECT SELECTOR PROJECT SELECTED`
export const UI_PROJECT_SELECTOR_PROJECT_REMOVED = `[UI] PROJECT SELECTOR PROJECT REMOVED`
export const UI_NOTIFICATION_BANNER_DISMISS = `[UI] NOTIFICATION BANNER DISMISS`
export const UI_FIRST_LOAD_BANNER_DISMISS = `[UI] FIRST LOAD BANNER DISMISS`
export const UI_SMS_ENABLED_BANNER_DISMISS = `[UI] SMS ENABLED BANNER DISMISS`
export const UI_SMS_ENABLED_BANNER_VIEW_SETTINGS = `[UI] SMS ENABLED BANNER VIEW SETTINGS`
export const UI_NOTIFICATION_BANNER_GO_TO_ORDER = `[UI] NOTIFICATION BANNER GO TO ORDER`

export const UI_ACCOUNT_PROJECT_SELECTOR_SELECT_ACCOUNT = `[UI] ACCOUNT PROJECT SELECTOR SELECT ACCOUNT`
export const UI_ACCOUNT_PROJECT_SELECTOR_SELECT_PROJECT = `[UI] ACCOUNT PROJECT SELECTOR SELECT PROJECT`

export const UI_PLACE_ORDER_LEAVE_PAGE_YES = `[UI] PLACE ORDER LEAVE PAGE YES`
export const UI_PLACE_ORDER_LEAVE_PAGE_NO = `[UI] PLACE ORDER LEAVE PAGE NO`
export const UI_PLACE_ORDER_REFRESH_PAGE_CONFIRM = `[UI] PLACE ORDER REFRESH PAGE CONFIRM`
export const UI_PLACE_ORDER_CREATE_ORDER = `[UI] PLACE ORDER CREATE ORDER`
export const UI_DATE_TIME_SELECTOR_SELECT_DATE_TIME = `[UI] DATE TIME SELECTOR SELECT DATE TIME`
export const UI_MODIFY_ORDER_DATE_TIME_SELECTOR_SELECT_DATE_TIME = `[UI] MODIFY ORDER - DATE TIME SELECTOR SELECT DATE TIME`
export const UI_ACCOUNT_PRODUCT_SELECTOR_SELECT_PRODUCT_DESCRIPTION = `[UI] ACCOUNT PRODUCT SELECTOR SELECT PRODUCT DESCRIPTION`
export const UI_ACCOUNT_PRODUCT_SELECTOR_SELECT_PRODUCT_CODE = `[UI] ACCOUNT PRODUCT SELECTOR SELECT PRODUCT CODE`
export const UI_QUALITY_SELECTOR_INCREASE = `[UI] QUALITY SELECTOR INCREASE`
export const UI_QUALITY_SELECTOR_DECREASE = `[UI] QUALITY SELECTOR DECREASE`
export const UI_SLUMP_SELECTOR_INCREASE = `[UI] SLUMP SELECTOR INCREASE`
export const UI_SLUMP_SELECTOR_DECREASE = `[UI] SLUMP SELECTOR DECREASE`
export const UI_QUALITY_SELECTOR_CHANGE = `[UI] QUALITY SELECTOR CHANGE`
export const UI_PLACE_ORDER_MODAL_CANCEL_ORDER = `[UI] PLACE ORDER MODAL CANCEL ORDER`
export const UI_PLACE_ORDER_MODAL_PLACE_ORDER = `[UI] PLACE ORDER MODAL PLACE ORDER`
export const UI_PLACE_ORDER_MODAL_OPEN_TERMS = `[UI] PLACE ORDER MODAL OPEN TERMS`
export const UI_PLACE_ORDER_MODAL_SWITCH_TERMS = `[UI] PLACE ORDER MODAL SWITCH TERMS`
export const UI_ORDER_PLACED_MODAL_PLACE_ANOTHER_ORDER = `[UI] ORDER PLACED MODAL PLACE ANOTHER ORDER`
export const UI_ORDER_PLACED_MODAL_GO_TO_ORDER = `[UI] ORDER PLACED MODAL GO TO ORDER`
export const UI_ORDER_PLACED_MODAL_GO_TO_ORDERS_LIST = `[UI] ORDER PLACED MODAL GO TO ORDERS LIST`
export const UI_ORDER_STATUS_SELECTOR_CONFIRMED = `[UI] ORDER STATUS SELECTOR CONFIRMED`
export const UI_ORDER_STATUS_SELECTOR_TO_BE_CONFIRMED = `[UI] ORDER STATUS SELECTOR TO BE CONFIRMED`
export const UI_ACCOUNT_PRODUCT_SELECTOR_SELECT_PRODUCT = `[UI] ACCOUNT PRODUCT SELECTOR SELECT PRODUCT`
export const UI_POUR_METHOD_CHANGE = `[UI] POUR METHOD CHANGE`
export const UI_TRUCK_SPACING_SELECTOR_CHANGE = `[UI] TRUCK SPACING SELECTOR CHANGE`
export const UI_TRUCK_SPACING_SELECTOR_DECREASE = `[UI] TRUCK SPACING SELECTOR DECREASE`
export const UI_TRUCK_SPACING_SELECTOR_INCREASE = `[UI] TRUCK SPACING SELECTOR INCREASE`
export const UI_FAB_PLACE_ORDER_CLICK = `[UI] FAB PLACE ORDER CLICK`
export const UI_DRIVER_INSTRUCTIONS_BLUR = `[UI] DRIVER INSTRUCTIONS BLUR`
export const UI_DRIVER_INSTRUCTIONS_FOCUS = `[UI] DRIVER INSTRUCTIONS FOCUS`
export const UI_ORDER_TRUCK_SIZE_SELECTOR = `[UI] ORDER TRUCK SIZE SELECTOR`
export const UI_PURCHASE_ORDER_SELECTOR_CHANGE = `[UI] PURCHASE ORDER SELECTOR CHANGE`
export const UI_PLACE_ORDER_PLUS_LOAD_HELP_OPEN = `[UI] PLACE ORDER PLUS LOAD HELP OPEN`
export const UI_PLACE_ORDER_PLUS_LOAD_HELP_CLOSE = `[UI] PLACE ORDER PLUS LOAD HELP CLOSE`
export const UI_PLACE_ORDER_PLUS_LOAD_TOGGLE_SWITCHED = `[UI] PLACE ORDER PLUS LOAD TOGGLE SWITCHED`
export const UI_PLACE_ORDER_PAGE_TIPS_OPEN = `[UI] PLACE ORDER PAGE TIPS OPEN`
export const UI_PLACE_ORDER_PAGE_TIPS_CLOSE = `[UI] PLACE ORDER PAGE TIPS CLOSE`
export const UI_SITE_CONTACT_NAME_BLUR = `[UI] SITE CONTACT NAME BLUR`
export const UI_SITE_CONTACT_NAME_FOCUS = `[UI] SITE CONTACT NAME FOCUS`
export const UI_SITE_CONTACT_PHONE_BLUR = `[UI] SITE CONTACT PHONE BLUR`
export const UI_SITE_CONTACT_PHONE_FOCUS = `[UI] SITE CONTACT PHONE FOCUS`
export const UI_TEST_FREQUENCY_SELECT = `[UI] TEST FREQUENCY SELECT`
export const UI_TEST_REQUIREMENTS_SELECT = `[UI] TEST REQUIREMENTS SELECT`
export const UI_TEST_NOTES_FOCUS = `[UI] TEST NOTES FOCUS`
export const UI_TEST_NOTES_BLUR = `[UI] TEST NOTES BLUR`
export const UI_LOT_NUMBER_SELECTOR_FOCUS = `[UI] LOT NUMBER SELECTOR FOCUS`
export const UI_LOT_NUMBER_SELECTOR_BLUR = `[UI] LOT NUMBER SELECTOR BLUR`
export const UI_ORDER_TIPS_BANNER_VIEW = `[UI] ORDER TIPS BANNER VIEW`
export const UI_ORDER_TIPS_BANNER_DISMISS = `[UI] ORDER TIPS BANNER DISMISS`

export const UI_HERE_MAPS_COMPONENT_SELECT = `[UI] HERE MAPS COMPONENT SELECT`
export const UI_HERE_MAPS_COMPONENT_SELECT_ERROR = `[UI] HERE MAPS COMPONENT SELECT ERROR`

export const UI_ORDER_DETAILS_PROJECT_CHIP_CLICK = `[UI] ORDER DETAILS PROJECT CHIP CLICK`
export const UI_ORDER_DETAILS_ACCOUNT_CHIP_CLICK = `[UI] ORDER DETAILS ACCOUNT CHIP CLICK`
export const UI_ORDER_DETAILS_MENU_CONFIRM_CLICK = `[UI] ORDER DETAILS MENU CONFIRM CLICK`
export const UI_ORDER_DETAILS_MENU_CANCEL_CLICK = `[UI] ORDER DETAILS MENU CANCEL CLICK`
export const UI_ORDER_DETAILS_ICON_CONFIRM_CLICK = `[UI] ORDER DETAILS ICON CONFIRM CLICK`
export const UI_ORDER_DETAILS_ICON_CANCEL_CLICK = `[UI] ORDER DETAILS ICON CANCEL CLICK`
export const UI_ORDER_DETAILS_MENU_CALL_CLICK = `[UI] ORDER DETAILS MENU CALL CLICK`
export const UI_ORDER_DETAILS_VIEW_TRUCKS_CLICK = `[UI] UI ORDER DETAILS - VIEW TRUCKS CLICK`
export const UI_TRUCKS_PANE_VIEW_TRUCKS_BTN = `TRUCKS PANE - VIEW TRUCKS BTN`
export const UI_VIEW_TRUCKS_CLICK = `TRUCKS PANE - VIEW TRUCKS CLICK`
export const UI_ON_FINISH_BUTTON_CLICK = `[UI] ON FINISH BUTTON CLICK`
export const UI_ON_FINISH_AND_REVIEW_BUTTON_CLICK = `[UI] ON FINISH AND REVIEW BUTTON CLICK`
export const UI_ON_BACK_ARROW_BUTTON_CLICK = `[UI] ON BACK ARROW BUTTON CLICK`
export const UI_ON_BACK_BUTTON_CLICK = `[UI] ON BACK BUTTON CLICK`
export const UI_ON_SUBMIT_BUTTON_CLICK = `[UI] ON SUBMIT BUTTON CLICK`
export const UI_EDIT_ORDER_CLOSE = `[UI] EDIT ORDER CLOSE`
export const UI_MODIFY_ORDER_OPEN_CLICK = `[UI] MODIFY ORDER OPEN CLICK`

export const UI_EDIT_ORDER_INFO_MODAL_OPEN = `[UI] EDIT ORDER INFO MODAL OPEN`
export const UI_EDIT_ORDER_MODAL_OPEN_TERMS = `[UI] EDIT ORDER MODAL OPEN TERMS`
export const UI_MODIFYING_INFO_MODAL_CLOSE = `[UI] MODIFYING INFO MODAL CLOSE`
export const UI_MODIFYING_INFO_MODAL_CONTINUE = `[UI] MODIFYING INFO MODAL CONTINUE`
export const UI_MODIFYING_INFO_MODAL_SWITCH = `[UI] MODIFYING INFO MODAL SWITCH`
export const UI_MODIFYING_INFO_MODAL_CANCEL = `[UI] MODIFYING INFO MODAL CANCEL`

export const UI_MODIFYING_ORDER_DATE_INFO_MODAL_CANCEL = `[UI] MODIFYING ORDER DATE INFO MODAL CANCEL`
export const UI_MODIFYING_ORDER_DATE_INFO_MODAL_CLOSE = `[UI] MODIFYING ORDER DATE INFO MODAL CLOSE`
export const UI_MODIFYING_ORDER_DATE_INFO_MODAL_CONTINUE = `[UI] MODIFYING ORDER DATE INFO MODAL CONTINUE`
export const UI_MODIFYING_ORDER_DATE_INFO_MODAL_SWITCH = `[UI] MODIFYING ORDER DATE INFO MODAL SWITCH`
export const UI_REFRESH_ORDERS_LIST_BUTTON = `[UI] REFRESH ORDERS LIST BUTTON`

// trucks
export const UI_ORDER_DETAIILS_TRUCK_PANE_TRUCKS_ON_MAP_DIALOG_OPEN = `ORDER DETAILS - TRUCK PANE TRUCKS ON MAP DIALOG OPEN`
export const UI_TRUCKS_ON_MAP_DIALOG_CLOSE = `TRUCKS MAP - DIALOG CLOSE`
export const UI_TRUCKS_ON_MAP_TRUCK_CLICKED = `TRUCKS MAP - TRUCK CLICKED`
export const UI_TRUCKS_ON_MAP_PLANT_CLICKED = `TRUCKS MAP - VIEW PLANT PIN CLICK`
export const UI_TRUCKS_ON_MAP_SITE_CLICKED = `TRUCKS MAP - VIEW SITE PIN CLICK`

// order modify done modal
export const UI_MODIFY_CONFIRMATION_MODAL_CLOSE = `[UI] MODIFY CONFIRMATION MODAL CLOSE`
export const UI_MODIFY_CONFIRMATION_GO_TO_ORDER_BTN = `[UI] MODIFY CONFIRMATION GO TO ORDER BTN`
export const UI_MODIFY_CONFIRMATION_GO_TO_ALL_ORDERS_BTN = `[UI] MODIFY CONFIRMATION GO TO ALL ORDERS BTN`
export const UI_NOTIFICATION_PANEL_INFORMATION_MODAL_OPEN = `[UI] NOTIFICATION PANEL INFORMATION MODAL OPEN`
export const UI_NOTIFICATION_PANEL_INFORMATION_MODAL_CLOSE = `[UI] NOTIFICATION PANEL INFORMATION MODAL CLOSE`
export const UI_NOTIFICATION_PANEL_ACCOUNT_SELECTED = `[UI] NOTIFICATION PANEL ACCOUNT SELECTED`
export const UI_NOTIFICATION_PANEL_PROJECT_SELECTED = `[UI] NOTIFICATION PANEL PROJECT SELECTED`
export const UI_NOTIFICATION_PANEL_ACCOUNT_REMOVED = `[UI] NOTIFICATION PANEL ACCOUNT REMOVED`
export const UI_NOTIFICATION_PANEL_PROJECT_REMOVED = `[UI] NOTIFICATION PANEL PROJECT REMOVED`
export const UI_NOTIFICATION_CONFIGS_SAVE = `[UI] NOTIFICATION CONFIGS SAVE`
export const UI_NOTIFICATION_CONFIG_TOGGLE_CHECKED = `[UI] NOTIFICATION CONFIG TOGGLE CHECKED`

// Notifications
export const UI_NOTIFICATIONS_NOTIFICATIONS_DIALOG_SETTINGS_ICON = `[UI] NOTIFICATIONS NOTIFICATIONS DIALOG SETTINGS ICON`
export const UI_NOTIFICATIONS_SETTINGS_DIALOG_FIRST_TRUCK_APP_OFF = `[UI] NOTIFICATIONS SETTINGS DIALOG FIRST TRUCK APP OFF`
export const UI_NOTIFICATIONS_SETTINGS_DIALOG_FIRST_TRUCK_APP_ON = `[UI] NOTIFICATIONS SETTINGS DIALOG FIRST TRUCK APP ON`
export const UI_NOTIFICATIONS_SETTINGS_DIALOG_LAST_TRUCK_APP_OFF = `[UI] NOTIFICATIONS SETTINGS DIALOG LAST TRUCK APP OFF`
export const UI_NOTIFICATIONS_SETTINGS_DIALOG_LAST_TRUCK_APP_ON = `[UI] NOTIFICATIONS SETTINGS DIALOG LAST TRUCK APP ON`
export const UI_NOTIFICATIONS_SETTINGS_DIALOG_ORDERS_PLACED_APP_OFF = `[UI] NOTIFICATIONS SETTINGS DIALOG ORDERS PLACED APP OFF`
export const UI_NOTIFICATIONS_SETTINGS_DIALOG_ORDERS_PLACED_APP_ON = `[UI] NOTIFICATIONS SETTINGS DIALOG ORDERS PLACED APP ON`
export const UI_NOTIFICATIONS_SETTINGS_DIALOG_ORDERS_MODIFIED_APP_OFF = `[UI] NOTIFICATIONS SETTINGS DIALOG ORDERS MODIFIED APP OFF`
export const UI_NOTIFICATIONS_SETTINGS_DIALOG_ORDERS_MODIFIED_APP_ON = `[UI] NOTIFICATIONS SETTINGS DIALOG ORDERS MODIFIED APP ON`
export const UI_NOTIFICATIONS_SETTINGS_DIALOG_FIRST_TRUCK_SMS_OFF = `[UI] NOTIFICATIONS SETTINGS DIALOG FIRST TRUCK SMS OFF`
export const UI_NOTIFICATIONS_SETTINGS_DIALOG_FIRST_TRUCK_SMS_ON = `[UI] NOTIFICATIONS SETTINGS DIALOG FIRST TRUCK SMS ON`
export const UI_NOTIFICATIONS_SETTINGS_DIALOG_LAST_TRUCK_SMS_OFF = `[UI] NOTIFICATIONS SETTINGS DIALOG LAST TRUCK SMS OFF`
export const UI_NOTIFICATIONS_SETTINGS_DIALOG_LAST_TRUCK_SMS_ON = `[UI] NOTIFICATIONS SETTINGS DIALOG LAST TRUCK SMS ON`
export const UI_NOTIFICATIONS_SETTINGS_DIALOG_ORDERS_PLACED_SMS_OFF = `[UI] NOTIFICATIONS SETTINGS DIALOG ORDERS PLACED SMS OFF`
export const UI_NOTIFICATIONS_SETTINGS_DIALOG_ORDERS_PLACED_SMS_ON = `[UI] NOTIFICATIONS SETTINGS DIALOG ORDERS PLACED SMS ON`
export const UI_NOTIFICATIONS_SETTINGS_DIALOG_ORDERS_MODIFIED_SMS_OFF = `[UI] NOTIFICATIONS SETTINGS DIALOG ORDERS MODIFIED SMS OFF`
export const UI_NOTIFICATIONS_SETTINGS_DIALOG_ORDERS_MODIFIED_SMS_ON = `[UI] NOTIFICATIONS SETTINGS DIALOG ORDERS MODIFIED SMS ON`

export const UI_NOTIFICATIONS_LAST_TRUCK_INAPP_VIEW_ORDER_BTN = `[UI] NOTIFICATIONS LAST TRUCK INAPP VIEW ORDER BTN`
export const UI_NOTIFICATIONS_LAST_TRUCK_INAPP_DISMISS = `[UI] NOTIFICATIONS LAST TRUCK INAPP DISMISS`

// Plus Load Button
export const UI_PLUS_LOAD_ACTION_MENU_GET_BTN = `[UI] PLUS LOAD ACTION MENU GET BTN` // Plus Load icon-button/menu-item in header/kebab menu
export const UI_PLUS_LOAD_DELIVERY_PANE_GET_BTN = `[UI] PLUS LOAD DELIVERY PANE GET BTN` // Plus Load button from Delivery Progress pane
export const UI_PLUS_LOAD_TRUCKS_PANE_GET_BTN = `[UI] PLUS LOAD TRUCKS PANE GET BTN` // Plus Load button on Concrete Deliveries pane
// Plus Load Form
export const UI_PLUS_LOAD_FORM_DIALOG_NEXT_BTN = `[UI] PLUS LOAD FORM DIALOG NEXT BTN`
export const UI_PLUS_LOAD_FORM_DIALOG_CALL_BORAL_LINK = `[UI] PLUS LOAD FORM DIALOG CALL BORAL LINK`
export const UI_PLUS_LOAD_FORM_DIALOG_CANCEL = `[UI] PLUS LOAD FORM DIALOG CANCEL` // (use cancel in 3 locations 1. on cancel button, 2. on close “x” icon and 3. black scrim)
export const UI_PLUS_LOAD_CONFIRMATION_DIALOG_SUBMIT_BTN = `[UI] PLUS LOAD CONFIRMATION DIALOG SUBMIT BTN`
// Plus Load Exception Modal
export const UI_PLUS_LOAD_TOO_LATE_DIALOG_CALL_BORAL_LINK = `[UI] PLUS LOAD TOO LATE DIALOG CALL BORAL LINK` // (link or button)
export const UI_PLUS_LOAD_TOO_LATE_DIALOG_CLOSE = `[UI] PLUS LOAD TOO LATE DIALOG CLOSE` // (close button, or scrim, or Cancel button)

export const UI_SECOND_PLUS_LOAD_MODAL_CLOSE = `[UI] SECOND PLUS LOAD MODAL CLOSE`
export const UI_SECOND_PLUS_LOAD_CALL_BORAL = `[UI] SECOND PLUS LOAD CALL BORAL`

// Account Page
export const UI_RESEND_INVITATION_ACCOUNT_PAGE_RESEND_INVITATION_BTN = `[UI] INVITATION ACCOUNT PAGE RESEND INVITATION BTN`
export const UI_RESEND_INVITATION_ACCOUNT_PAGE_RESEND_DIALOG_SEND_BTN = `[UI] INVITATION ACCOUNT PAGE RESEND DIALOG SEND BTN`
export const UI_RESEND_INVITATION_ACCOUNT_PAGE_RESEND_DIALOG_CANCEL = `[UI] INVITATION ACCOUNT PAGE RESEND DIALOG CANCEL` // (applies to both the cancel button and clicking outside the modal)
export const UI_ACCOUNT_PAGE_INVITE_DIALOGUE_SUPER_USER_CLICK = `[UI] ACCOUNT PAGE INVITE DIALOGUE SUPER USER CLICK`
export const UI_ACCOUNT_PAGE_INVITE_DIALOGUE_STANDARD_USER_CLICK = `[UI] ACCOUNT PAGE INVITE DIALOGUE STANDARD USER CLICK`
export const UI_ACCOUNT_PAGE_INVITE_DIALOGUE_SEND_INVITATION_BTN = `[UI] ACCOUNT PAGE INVITE DIALOGUE SEND INVITATION BTN`
export const UI_ACCOUNT_PAGE_INVITE_DIALOGUE_CANCEL = `[UI] ACCOUNT PAGE INVITE DIALOGUE CANCEL` // (Includes both cancel button and clicking outside the dialog)
export const UI_ACCOUNT_PAGE_PEOPLE_VIEW_ALL_FILTER = `[UI] ACCOUNT PAGE PEOPLE VIEW ALL FILTER`
export const UI_ACCOUNT_PAGE_PEOPLE_SUPER_USERS_FILTER = `[UI] ACCOUNT PAGE PEOPLE SUPER USERS FILTER`
export const UI_ACCOUNT_PAGE_STANDARD_USERS_FILTER = `[UI] ACCOUNT PAGE STANDARD USERS FILTER`
export const UI_ACCOUNT_PAGE_PENDING_INVITATION_FILTER = `[UI] ACCOUNT PAGE PENDING INVITATION FILTER`
// export const UI_ACCOUNT_PAGE_UPGRADE_USER_CLICK = `[UI] ACCOUNT PAGE UPGRADE USER CLICK`
// export const UI_ACCOUNT_PAGE_DOWNGRADE_USER_CLICK = `[UI] ACCOUNT PAGE DOWNGRADE USER CLICK`
// export const UI_ACCOUNT_PAGE_REMOVE_FROM_ACCOUNT_CLICK = `[UI] ACCOUNT PAGE REMOVE FROM ACCOUNT CLICK`
// export const UI_ACCOUNT_PAGE_INVITE_USER_BTN = `[UI] ACCOUNT PAGE INVITE USER BTN`

// other
export const ADD_TO_HOMESCREEN_DISMISS = `ADD TO HOMESCREEN - DISMISS`
export const ADD_TO_HOMESCREEN_ANDROID_DISMISS = `ADD TO HOMESCREEN ANDROID - DISMISS`
